import { Button } from 'blaze-ui/Button'
import { MenuTrigger } from 'components/MenuTrigger/MenuTrigger'
import { Menu } from 'components/Menu/Menu'
import { ImageNodeAttrs } from 'common/Prose/nodeViews/Image/Types'
import { Item } from '@react-stately/collections'
import { useCloudinary } from 'providers/CloudinaryProvider/CloudinaryProvider'
import { useImageStore } from 'stores/ImageStore'
import { Image03 } from 'blaze-ui/icons/24'
import { Key } from 'react'

interface Props {
  attrs: ImageNodeAttrs
  onEdit: () => void
}

export const ContentMenu = ({ attrs, onEdit }: Props) => {
  const { src } = attrs
  const imageStore = useImageStore()
  const cloudinary = useCloudinary()

  const handleEffect = async (key: Key) => {
    if (!cloudinary) return

    const image = cloudinary.image(src.split('?')[0]).setDeliveryType('fetch')

    switch (key) {
      case 'generative_remove':
      case 'generative_background_replace':
        imageStore.clearVariants()
        imageStore.createVariant({
          image,
          url: image.toURL(),
          action: key,
        })
    }

    onEdit()
  }

  return (
    <MenuTrigger>
      <Button frontIcon={Image03} variant="tertiary" rounded size="xs">
        Content
      </Button>
      <Menu onAction={handleEffect} aria-label="Content">
        <Item key="generative_remove">Remove</Item>
        <Item key="generative_background_replace">Replace Background</Item>
      </Menu>
    </MenuTrigger>
  )
}
